import { render, staticRenderFns } from "./user-profile-details.vue?vue&type=template&id=3b828804&scoped=true&"
import script from "./user-profile-details.vue?vue&type=script&lang=js&"
export * from "./user-profile-details.vue?vue&type=script&lang=js&"
import style0 from "./user-profile-details.vue?vue&type=style&index=0&id=3b828804&lang=scss&scoped=true&"
import style1 from "./user-profile-details.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b828804",
  null
  
)

export default component.exports